import axios from "axios";
const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL;

export const bulkHomeService = {
  async fetchManufacturers() {
    const response = await axios.get(`${API_BASE_URL}/bulk/manufacture`);
    return response.data;
  },

  async fetchProducts(manufactureName: string) {
    const response = await axios.get(
      `${API_BASE_URL}/bulk/product/${encodeURIComponent(manufactureName)}`
    );
    return response.data;
  },
  async fetchProductsWithProductID(productID: string) {
    const response = await axios.get(
      `${API_BASE_URL}/product/${encodeURIComponent(productID)}`
    );
    return response.data;
  },
};
